<template>
  <div v-if="bannerText" class="home-banner-container">
    <div class="home-banner-left-content z-10">
      <div v-motion-fade>
        <heading-with-highlights
          textLocation="home"
          :text="bannerText"
          :highlight="textHighlight"
        />

        <p class="text-white text-heading-1 apercu-light py-[20px]">
          {{ subHeaderText }}
        </p>

        <button-default :buttonText="ctaText" :redirection="ctaRedirection" />
      </div>
    </div>

    <div v-if="image" class="home-banner-right-content" v-motion-fade>
      <img
        width="640"
        height="360"
        :src="parseSanityImage(image).url() as string"
        :alt="image.alt"
        class="w-full"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from "vue";
import HeadingWithHighlights from "@/components/atom/text/HeadingWithHighlights.vue";
import ButtonDefault from "@/components/atom/button/ButtonDefault.vue";
import { parseSanityImage } from "@/js/composable/parseSanityImage";

const props = defineProps({
  bannerText: {
    type: String,
    default: "All in one sales engagement platform for inside sales teams",
  },
  textHighlight: {
    type: String,
    default: "sales engagement",
  },
  subHeaderText: {
    type: String,
    default: "Spend less time prospecting and more time qualifying leads",
  },
  ctaText: {
    type: String,
    default: "Request a demo",
  },
  ctaRedirection: {
    type: String,
    default: "#",
  },
  image: {
    type: Object,
    default: () => ({}),
  },
});

const { bannerText, textHighlight, subHeaderText, ctaText, ctaRedirection } = toRefs(props);

</script>
